// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__18m9n","inputWrap":"Table_inputWrap__3P_xo","col":"Table_col__311lM","bmiTooltip":"Table_bmiTooltip__3Vb5K"};